var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('vue-repeater',{model:{value:(_vm.fields),callback:function ($$v) {_vm.fields=$$v},expression:"fields"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }